// tp wallet router

import Layout from "@/layout";


const parentRoute = {
  path: "/payments",
  component: Layout,
  meta: {
    title: "Fuel Deals",
    icon: "wallet",
    tag: "ic-new-tag",
    tagWidth: "29px",
    tagHeight: "12px",
  },
}

export default {
  ...parentRoute,
  children: [
    {
      path: "find-deals",
      name: "findDeals",
      component: () => import("@/views/wallet-common/index.vue"),
      meta: {
        title: "Search Fuel Deals",
        system: "wallet",
        keepAlive: true,
        interceptOverlay: '/payments/landing?redirect=/payments/find-deals&refresh=1'
      },
    },
    {
      path: "fuel-order",
      name: "fuelOrder",
      component: () => import("@/views/wallet-common/index.vue"),
      meta: { title: "Fuel Orders", system: "wallet", showBack: true,interceptOverlay: '/payments/landing?redirect=/payments/fuel-order&refresh=2'},
    },
    {
      path: "transactions",
      name: "transactions",
      component: () => import("@/views/wallet-common/index.vue"),
      meta: { title: "Fuel Transactions", system: "wallet",interceptOverlay: '/payments/landing?redirect=/payments/transactions&refresh=3'},
    },
  ], 
};

export const Nologin =  {
  ...parentRoute,
  hidden: true,
  children: [
    {
      path: "landing",
      name: "Landing",
      component: () => import("@/views/wallet-common/index.vue"),
      meta: { title: "Landing", system: "wallet" },
      hidden: true
    },
  ]
}
